export const MAP_LANDMARKS_BULK_OPEN_MODAL = "MAP_LANDMARKS_BULK_OPEN_MODAL";
export const MAP_LANDMARKS_BULK_UPDATE = "MAP_LANDMARKS_BULK_UPDATE";
export const MAP_LANDMARKS_BULK_UPDATE_RESPONSE = "MAP_LANDMARKS_BULK_UPDATE_RESPONSE";